import React, { ComponentType } from 'react'
import { connect } from 'react-redux'
import {
  Container,
  Grid,
  Icon,
  Message,
  Segment
} from 'semantic-ui-react'
// Local
import { RootState } from '../../store'
import ReveleerCoachingBox from '../ReveleerCoachingBox'
import If from '../common/if'
import { shouldRenderReskin2025 } from '../../constant'

const SafeSegment = Segment as unknown as ComponentType<any>
const SafeGrid = Grid as unknown as ComponentType<any>

const mapStateToProps = (state: RootState) => ({
  currentUser: state.user
})

type ReduxStateProps = ReturnType<typeof mapStateToProps>

type Props = ReduxStateProps

function AdminWelcome(
  props: Props
) {
  const { currentUser } = props


  return (
    <div className="header-padding">
      <Container>
        <SafeSegment
          attached
          className="no-margin"
        >
          <SafeGrid>
            <Grid.Row>
              <Grid.Column
                mobile={ 16 }
                tablet={ 16 }
                computer={ 16 }
              >
                <If isTrue={ shouldRenderReskin2025 }>
                  <ReveleerCoachingBox
                    coachingBoxType="infoNegative"
                    isShowing
                    message={
                      <>
                        <h3>
                          Hello { currentUser.username }
                        </h3>
                        <p>
                          It looks like you are logged into the client as an Admin.
                        </p>
                        <p>
                          You will see this message if you signed out of a
                        </p>
                        <p>
                          <span className="italic"> Run-As </span>
                          user context. If so, just close the tab and return to the
                          Admin application.
                        </p>
                      </>
                    }
                  />
                </If>
                <If isTrue={ !shouldRenderReskin2025 }>
                  <Message
                    warning
                    icon
                  >
                    <Icon name="info circle" />
                    <Message.Content>
                      <Message.Header>
                        Hello { currentUser.username }
                      </Message.Header>
                      <div className="m-1-top">
                        It looks like you are logged into the client as an Admin.
                      </div>
                      <div className="m-1-top">
                        You will see this message if you signed out of a
                        <span className="italic"> Run-As </span>
                        user context. If so, just close the tab and return to the
                        Admin application.
                      </div>
                    </Message.Content>
                  </Message>
                </If>
              </Grid.Column>
            </Grid.Row>
          </SafeGrid>
        </SafeSegment>
      </Container>
    </div>
  )
}

export default connect(mapStateToProps)(AdminWelcome)
